/* eslint-disable */

import moment from 'moment';
import React, { useState, useRef, useEffect } from 'react';
import DateRangePicker from './RedesignedDatePicker';
import { gsc_report_query, query } from '../../FilterOptions/query';
import getDataRange from '../../../helpers/getDataRange';
import Loading from '../../Loading';

const DateRangePickerContainer = (props) => {
    const [open, setOpen] = useState(false);
    const [minMaxDates, setMinMaxDates] = useState({});
    const [loadMinMax, setLoadMinMax] = useState(true);
    const dropdownRef = useRef(null);

    const countFromToday = props.is_from_tools || props.is_from_ai_tracking;

    const handleToggle = () => setOpen((prev) => !prev);

    const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setOpen(false);
        }
    };

    const getMinMax = async () => {
        const domainId = window.location.pathname?.split('/')?.[2];

        let minmaxData =
            JSON.parse(
                localStorage.getItem(
                    props.gsc_report ? 'search-summary-min-max-date' : 'global-min-max-date',
                ),
            ) ?? {};

        setLoadMinMax(true);

        const request = props.gsc_report ? gsc_report_query : query;
        const data = await request.update({ force: true });
        setMinMaxDates(data?.[0] ?? {});
        window.minMaxDates = data?.[0] ?? {};
        const body = {
            data: data?.[0] ?? {},
            createdAt: new Date(),
        };
        minmaxData[domainId] = body;
        localStorage.setItem(
            props.gsc_report ? 'search-summary-min-max-date' : 'global-min-max-date',
            JSON.stringify(minmaxData),
        );
        setLoadMinMax(false);
    };

    const setDateForAI = () => {
        const firstPromptCreatedDate = window.firstPromptCreatedDate
            ? new Date(window.firstPromptCreatedDate)
            : new Date();
        const data = {
            mindate: {
                value: firstPromptCreatedDate,
            },
            maxdate: {
                value: new Date(),
            },
        };
        setMinMaxDates(data);
        setLoadMinMax(false);
    };

    useEffect(() => {
        if (props.is_from_tools) return setLoadMinMax(false);
        if (props.is_from_ai_tracking) return setDateForAI();
        if (window?.filters?.fns) {
            window.refreshMinMax = getMinMax;
        }
        if (window.minMaxDates) {
            setMinMaxDates(window.minMaxDates);
            return setLoadMinMax(false);
        }
        getMinMax();
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const default_filter = urlParams.get('default_filter');
        if (default_filter === 'today' && window?.filters?.filters?.dates?.id !== 'current_day') {
            const todayOption = props.options.find((item) => item.id === 'current_day');
            if (!todayOption) return;
            const choiceValue = getDataRange(todayOption);
            const selectedChoice = { ...todayOption, values: choiceValue };
            props.updateSelect(selectedChoice);
        }
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('updateProjectCreationDate', setDateForAI);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('updateProjectCreationDate', setDateForAI);
        };
    }, []);

    const { start_date, end_date } = getDataRange(
        window?.filters?.filters?.dates,
        countFromToday,
        minMaxDates?.maxdate?.value,
    );

    useEffect(() => {
        const { start_date, end_date } = getDataRange(
            window?.filters?.filters?.dates,
            countFromToday,
            minMaxDates?.maxdate?.value,
        );
        if (!minMaxDates?.mindate?.value || !end_date?.value) return;

        const minDate = moment(minMaxDates.mindate.value);
        const endDateMoment = moment(end_date.value);

        if (endDateMoment.isBefore(minDate, 'day')) {
            const last7DaysOption = props.options.find((item) => item.id === '7_days');
            if (last7DaysOption) {
                const choiceValue = getDataRange(last7DaysOption);
                const selectedChoice = { ...last7DaysOption, values: choiceValue };
                props.updateSelect(selectedChoice);
            }
        }
    }, [minMaxDates]);

    return (
        <div className="dropdown-container" ref={dropdownRef}>
            <button onClick={handleToggle} className="date-picker-global-input">
                <span className="d-flex gap-8 align-items-center">
                    <i className="icon-calendar1" />
                    {loadMinMax ? (
                        <Loading />
                    ) : (
                        <>
                            {moment(start_date?.value).format('DD MMM YYYY')} -{' '}
                            {moment(end_date?.value).format('DD MMM YYYY')}
                        </>
                    )}
                </span>
                {/* <i className="icon-fi_chevron-down" /> */}
            </button>

            {!loadMinMax && open && (
                <div className="dropdown-panel">
                    <div className="calendar-wrapper">
                        <DateRangePicker
                            updateSelect={props.updateSelect}
                            options={props.options}
                            dateFilterValue={props.dateFilterValue}
                            gsc_report={props.gsc_report}
                            onClose={() => setOpen(false)}
                            minDate={minMaxDates?.mindate?.value}
                            maxDate={minMaxDates?.maxdate?.value}
                            is_from_tools={props.is_from_tools}
                            is_from_ai_tracking={props.is_from_ai_tracking}
                            defaultStartDate={start_date?.value}
                            defaultEndDate={end_date?.value}
                            hasOptions
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default DateRangePickerContainer;
